const CogCatalogTagTypes = [
    { value: "is_low_price", text: "LowPrice" },
    { value: "is_neg_gp", text: "NegGP" },
];

export default CogCatalogTagTypes;
